import './About.css'

import Present from '../../components/Present/Present'

export default function About () {
    return (
        <main>
            <Present />
        </main>
    )
}